
import React from 'react';

const ErrorModal= ({ isOpen, title = "Hubo un problema", message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/60 backdrop-blur-sm animate-in fade-in duration-300 px-4">
      <div 
        className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-8 max-w-sm w-full transform animate-in zoom-in-95 duration-200 border border-gray-100 dark:border-slate-800 border-t-4 border-t-red-500"
        role="alert"
        aria-modal="true"
      >
        <div className="text-center">
          <div className="w-16 h-16 bg-red-100 dark:bg-red-500/10 text-red-600 dark:text-red-400 rounded-full flex items-center justify-center mx-auto mb-5 shadow-inner">
            <i className="fas fa-exclamation-circle text-2xl"></i>
          </div>
          
          <h2 className="text-xl font-black text-gray-800 dark:text-slate-100 mb-3 tracking-tight">
            {title}
          </h2>
          
          <p className="text-sm text-gray-600 dark:text-slate-400 mb-8 leading-relaxed">
            {message}
          </p>

          <button
            onClick={onClose}
            className="w-full bg-slate-800 dark:bg-slate-700 hover:bg-slate-900 dark:hover:bg-slate-600 text-white font-bold py-3 px-6 rounded-2xl transition-all duration-200 active:scale-95 shadow-lg shadow-slate-200 dark:shadow-none"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
